<template>
  <div :class="`content-section ${classes}`" compact>
    <div class="d-flex gap-10px">
      <span v-if="icon" v-html="icon"></span>
      <span class="h4 bold m-0">{{ title }}</span>
    </div>
    <p v-if="description" class="h6">
      {{ description }}
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'content-section',
  props: {
    icon: String,
    title: String,
    description: String,
    classes: String,
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  @extend .panel !optional;
  margin-bottom: 1rem !important;

  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
